import React, { FunctionComponent, useCallback } from 'react';
import { PrimaryLargeButtonFlex, SecondaryLargeButtonFlex } from '@Components/controls/Button/Button';
import { setModal } from '@Redux/modules/modal/actions';
import useTranslate from '@Utils/hooks/useTranslate';
import { getLang } from '@Utils/language/language';
import { BodyM } from '@Components/Typography/Typography.styled';
import { isRTL } from '@Utils/layout/layoutSupport';
import { Col, Row } from 'react-grid-system';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CardContainer, TextContainer } from './PaymentSummaryAction.styled';

const PaymentSummaryAction: FunctionComponent<types.cards.IPaymentSummaryActionCardProps> = ({
	params: { exceptionDescription, tryAgainWithEditPaymentCard = () => {} },
}) => {
	const { translate } = useTranslate();
	const dispatch = useDispatch();
	const history = useHistory();

	const closeModal = useCallback(() => {
		dispatch(
			setModal({
				type: null,
				data: null,
			})
		);
	}, []);

	return (
		<CardContainer>
			<Row>
				<Col>
					<TextContainer>
						<BodyM color="black87">{exceptionDescription}</BodyM>
						<BodyM color="black87">{translate('payment-summary-action.want-to-edit')}</BodyM>
					</TextContainer>
				</Col>
			</Row>
			<Row>
				<Col md={2} sm={6} offset={{ md: isRTL() ? 0 : 4 }} style={{ padding: '10px 15px 10px 15px' }}>
					<SecondaryLargeButtonFlex
						onClick={() => {
							closeModal();
							tryAgainWithEditPaymentCard();
						}}
						uniqueId="payment-summary-action.modal.yes"
					>
						{translate('payment-summary-action.yes')}
					</SecondaryLargeButtonFlex>
				</Col>
				<Col md={2} sm={6} style={{ padding: '10px 15px 10px 15px' }}>
					<PrimaryLargeButtonFlex
						uniqueId="payment-summary-action.modal.push.to.store"
						onClick={() => {
							closeModal();
							history.push(`/${getLang()}/store`);
						}}
					>
						{translate('payment-summary-action.no')}
					</PrimaryLargeButtonFlex>
				</Col>
			</Row>
		</CardContainer>
	);
};

export default PaymentSummaryAction;
